import { useEffect, useState } from "react";

/**
 * Hook to detect when Largest Contentful Paint (LCP) has occurred
 * Returns true when LCP is complete, allowing animations to start safely
 */
export const useLCPDetection = () => {
	const [lcpCompleted, setLcpCompleted] = useState(false);

	useEffect(() => {
		// Always set a maximum fallback timer to ensure slider starts
		const maxWaitTimer = setTimeout(() => {
			// console.log("LCP: Fallback timer triggered");
			setLcpCompleted(true);
		}, 5000);

		// Server-side or environments without PerformanceObserver
		if (typeof window === "undefined" || !window.PerformanceObserver) {
			// console.log("LCP: No PerformanceObserver, using fallback");
			return () => clearTimeout(maxWaitTimer);
		}

		let detected = false;
		const observer = new PerformanceObserver(_list => {
			if (!detected) {
				detected = true;
				// console.log("LCP: Detected via PerformanceObserver");
				clearTimeout(maxWaitTimer);
				// Small delay after LCP to ensure rendering is stable
				setTimeout(() => setLcpCompleted(true), 200);
			}
		});

		try {
			observer.observe({ entryTypes: ["largest-contentful-paint"] });
			// console.log("LCP: Observer started");
		} catch (_error) {
			// console.log("LCP: Observer failed, using fallback", error);
			// Fallback will be handled by maxWaitTimer
		}

		return () => {
			observer.disconnect();
			clearTimeout(maxWaitTimer);
		};
	}, []);

	return lcpCompleted;
};
